import React from 'react';
import styled from 'styled-components';
import { AnalyticsPromos } from '../utils/analytics';
import { PromoFeaturedType } from '../types/entities';
import { PictureWithSources } from './common/PictureWithSources';

const Picture = styled(PictureWithSources)`
    display: block;
    aspect-ratio: 438 / 242;
`;

type Props = {
  promo: PromoFeaturedType
};

type State = {
  analytics_setup:boolean
};

class PromosFeatured extends React.PureComponent<Props, State> {
  private ref:React.RefObject<HTMLAnchorElement> = React.createRef();

  constructor(props:Props) {
    super(props);

    this.onClick = this.onClick.bind(this);
    this.setup = this.setup.bind(this);
    this.state = { analytics_setup: false };
  }

  componentDidMount() {
    this.setup();
  }
  
  componentDidUpdate() {
    this.setup();
  }

  setup() {
    if (!this.ref.current || this.state.analytics_setup) return;

    this.setState({ analytics_setup: true });
    const { promo } = this.props;
    setTimeout(() => {
      AnalyticsPromos.observe('promo_featured', promo.id, promo.title, this.ref.current);
    }, 1500);
  }

  onClick(event:React.MouseEvent<HTMLElement>) {
    const { promo } = this.props;
    const openInNewWindow = promo.target !== '_self' || event.altKey || event.ctrlKey || event.shiftKey;
    AnalyticsPromos.trackClick('promo_featured', promo.id, promo.title, openInNewWindow ? null : () => {
        document.location = promo.url;
    });
    if (!openInNewWindow) event.preventDefault();
  }

  render() {
    const { promo } = this.props;

    if (!promo || !promo.images.thumb_v2 || !Object.keys(promo.images.thumb_v2).length) {
      return '';
    }

    /* @todo let the browser decide which format to use based on support */
    return (
      <a href={promo.url} className="o-ad-w-100" ref={this.ref} onClick={this.onClick}>
        <Picture
          images={promo.images.thumb_v2}
          fallback={promo.thumb_v2}
          title={promo.title}
          lazy
        />
      </a>
    );
  }
}

export default PromosFeatured;